import React, { useState, useEffect, useRef } from "react";
import { useAuth } from '../context/AuthContextProvider';


import {
  AppLayout,
  BreadcrumbGroup,
  Container,
  Box,
  Cards,
  Button,
  Header,
  Table,
  Badge,
  Autosuggest,
  ExpandableSection,
  SpaceBetween,
  Multiselect,
  ColumnLayout,
  Tabs,
  Pagination,
  Spinner,
  ButtonDropdown,
  CopyToClipboard,
  ContentLayout,
  Icon,
  PieChart,
  Select,
  HelpPanel,
  Grid,
  Steps,
  Popover,
  SegmentedControl,
  TextContent,
  Toggle,
  Link,
  Modal,
  FormField,
  Input
} from "@amzn/awsui-components-react";

import "./homepage.scss";
import { useSelector, useDispatch } from "react-redux";

import { useHistory } from "react-router-dom";
import { useLocation, useParams } from "react-router-dom";


import CPBoardView from "./ClosePortal/components/CPBoardView"
import CustomMultipleResourcePage from "./ClosePortal/components/CustomMultipleResourcePage"
import CustomSingleResourcePage from "./ClosePortal/components/CustomSingleResourcePage"
import { getBrassIsLDAPOwnerOf, getOwnersByUser, getOwnersForAdminUser, getOwnerCustomTabs, hideOrUnhideCPTab, getOwnerTabPreferences, createCustomTabOfOwner, updateCustomTabOfOwner, deleteCustomTabOfOwner, createClosePortalOwner, updateClosePortalOwner, getOwnerDetails } from "src/utilities/CloseAPIs"
import { TEMPLATE_APP} from 'src/Ateam-BI/Templates/Constants';

import { checkIfSupportAdmin, checkIfPortalAdmin } from 'src/checkPageAccess';
import { configureGenericAppSync, configurePlusAppsync } from 'src/context/AuthContextUtility';
import { isMemberOf } from "src/checkPageAccess";

import {closePortalDefaultTabs} from "./ClosePortal/constants"
import { getEditableFields } from "src/Ateam-BI/Templates/Utils/FormMetadata";
import { useDirectReports } from "src/hooks/useSuggestedLogins";
import {getServiceForMetricsByPath, captureMetrics, createKatalTimerStopWatch, publishTimerStopwatchMetric} from "src/katalMetrics/metricsHelperMethods"
import { getLocalCache, setLocalCache } from "src/utilities/CacheHelper"
import { GET_OWNERS_CACHE_KEY, cacheVariables } from "src/AppConstants/CacheConstants"
import { saveTabOrder, getTabOrder, applyTabOrder, applyTabOrderWithFixedTabs, getVisibleTabNames, getReorderableTabs, cleanupTabOrder, FIXED_TABS } from "src/utilities/TabOrderUtils"




import Apps from "./Apps"
import CreateTeamModal from "./CreateTeamModal"
import CustomizeTabsModal from "./CustomizeTabsModal"
import { getClosePortalBanners } from "src/Ateam-BI/Banners/BannerUtils";
import BannerContainer from "src/Ateam-BI/Banners/BannerContainer";
import { BannerDisplayLocation } from "src/Ateam-BI/Banners/BannerTypes";


const AllProducts = (props) => {
  const history = useHistory();
  const isCurrentAppAuthorised = useSelector(
    (globalState) => globalState.auth.isCurrentAppAuthorized
  );

  const { tabIdFromURL } = useParams()
  const { id } = useParams()

  const userAuthenticationDetails = useAuth();
  const firstName = userAuthenticationDetails.GivenName;
  const currentUser = useSelector((globalState) => globalState.auth.userId)
  const currentStage = useSelector((globalState) => globalState.auth.currentStage)
  const ln = useLocation()
  const search = useLocation().search
  const [activeTabId, setActiveTabId] = useState();
  const [activeHref, setActiveHref] = useState()
  const [visible, setVisible] = useState(false)
  const [customizeTabsVisible, setCustomizeTabsVisible] = useState(false)

  const isPortalAdmin = useSelector((globalState)=>globalState.auth.isPortalAdmin)
  const isSupportAdmin = useSelector((globalState)=>globalState.auth.isSupportAdmin)
  const [showLoadingIcon, setShowLoadingIcon] = useState(true)
  const [selectedCPView, setSelectedCPView] = useState ()
  const [cpOwnerOptions, setCpOwnerOptions] = useState([])
  const [viewAccess, setViewAccess] = useState()
  const [addOrEditAccess, setAddOrEditAccess] = useState()
  const searchParams = new URLSearchParams(search)
  const currentHour = (new Date()).getHours()
  const [errorText, setErrorText] = useState()
  const [selectedSegmentId, setSelectedSegmentId] = useState("tab-controls")
  const [selectedTabControlsSegmentId, setSelectedTabControlsSegmentId] = useState("add")
  const [selectedUpdateOrDeleteTab, setSelectedUpdateOrDeleteTab] = useState()
  const [selectedTabToUnhide, setSelectedTabToUnhide] = useState()
  const [updateTabNameInput, setUpdateTabNameInput] = useState('')
  const [newTabName, setNewTabName] = useState('')
  const [banners, setBanners] = useState([]);
  const [greeting, setGreeting] = useState(() => {
    if (currentHour < 12) {
      return "Good Morning"
    } else if (currentHour < 18) {
      return "Good Afternoon"
    } else {
      return "Good Evening"
    }
  })
  const [inIframe, setInIframe] = useState(window.self !== window.top)
  const [tabs, setTabs] = useState([])
  const [allTabs, setAllTabs] = useState([])
  const [allCustomTabs, setAllCustomTabs] = useState([])
  const [hiddenTabs, setHiddenTabs] = useState([])
  const [modalLoading, setModalLoading] = useState(false)
  const [fieldMetadata, setFieldMetadata] = useState({});
  const [regions, setRegions] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([])  
  const [selectedOrgs, setSelectedOrgs] = useState([])
  const [selectedVP, setSelectedVP] = useState()
  const [newTeamName, setNewTeamName] = useState('')
  const [newTeamLDAP, setNewTeamLDAP] = useState('')
  const { directReports, directReportsLoading, getDirectReportsCaller } = useDirectReports();
  const [customTabsLoaded, setCustomTabsLoaded] = useState(false)
  const [fetchedHiddenTabsOfOwner, setFetchedHiddenTabsOfOwner] = useState(false)
  
  const [selectedTeamToEdit, setSelectedTeamToEdit] = useState(null)
  const [isAteamBI, setIsAteamBI] = useState(null)
  const [selectedTabType, setSelectedTabType] = useState()

  const getCachedOwners = () => getLocalCache(GET_OWNERS_CACHE_KEY, cacheVariables[GET_OWNERS_CACHE_KEY]?.expiry);
  const setCachedOwners = (data) => setLocalCache(GET_OWNERS_CACHE_KEY, data);

    useEffect(() => {
        setInIframe(window.self !== window.top)
    }, [])

    useEffect(()=>{
      if(ln.pathname?.toLowerCase()?.startsWith('/appslibrary')){
         setActiveTabId('AppsLibrary')
      }else{
        let tabId = tabIdFromURL ? tabIdFromURL?.replaceAll('%2F', '/') : 'HOME';
        setActiveTabId(tabId)
      }
    }, [ln, tabIdFromURL])

    useEffect(()=> {
      if(selectedCPView) { 
      setTabs([])
      setTabOrderLoaded(false)
      setFetchedHiddenTabsOfOwner(false) 
      fetchHiddenTabsOfOwner()
      updateAccess()
      updateCustomTabs()
      if(activeTabId && activeTabId?.toLocaleLowerCase() !== 'appslibrary' && selectedCPView?.value ) {
        if(searchParams.toString() && activeTabId?.toLowerCase() !== 'home') {
          history.push(`/ClosePortal/${activeTabId?.replaceAll('/','%2F')}/Page/${selectedCPView?.value}?${searchParams.toString()}`)
        } else {
          history.push(`/ClosePortal/${activeTabId?.replaceAll('/', '%2F')}/Page/${selectedCPView?.value}`)
        }
      }
    }
    },[selectedCPView])

    useEffect(() => {
      if(customTabsLoaded === true) {
        if(!closePortalDefaultTabs?.filter((t) => (hiddenTabs?.includes(t?.id) ? false : true))?.map((tab)=>(tab?.id)).concat(tabs?.map((t) => (t?.tab)))?.includes(tabIdFromURL?.replaceAll('%2F', '/')) && activeTabId?.toLowerCase() !== 'appslibrary') {
          setActiveTabId('HOME')
          history.push(`/ClosePortal/HOME/Page/${selectedCPView?.value}`)
        } 
      }
    }, [customTabsLoaded, hiddenTabs])


    useEffect(()=> {
      if(visible === true && allTabs?.length <= 0) {
        loadSearchDropDownValues()
      }
    },[visible])

    useEffect(()=> {
      if(customizeTabsVisible === true && allTabs?.length <= 0) {
        fetchAllTabsOfOwner()
        fetchHiddenTabsOfOwner()
      }
    },[customizeTabsVisible])

    useEffect(() => {
      setUpdateTabNameInput('')
      setNewTabName('')
      setSelectedTabToUnhide()
      setSelectedUpdateOrDeleteTab()
      setSelectedOrgs([])
      setSelectedRegions([])
      setNewTeamName('')
      setNewTeamLDAP('')
      setSelectedVP()
      if(selectedSegmentId === 'create-team') {
        loadSearchDropDownValues()
      }
    },[selectedSegmentId, selectedTabControlsSegmentId])

  useEffect(() => {
    // loadData()
    checkAteamBIMembership()
  },[])

  useEffect(() => {
    if (isAteamBI != null) {
      loadData()
    }

  }, [isAteamBI])


  useEffect(() => {
    const orgs = fieldMetadata[TEMPLATE_APP.ORGANIZATION]?.values;
    setOrganizations(orgs);

    const regions = fieldMetadata[TEMPLATE_APP.REGION]?.values
    setRegions(regions)

  }, [fieldMetadata])


  const loadSearchDropDownValues = async () => {
    setModalLoading(true)
    let res = await getEditableFields()
    setFieldMetadata(res)
    setModalLoading(false)        
  }

  const handleOwnerSelection = (ownerSelectOptions) => {
    if (ownerSelectOptions.length > 0) {
      if(id) {
        const index = ownerSelectOptions?.findIndex((element) => {
          return element?.value == id
        })
        if(index === -1) {
          setSelectedCPView(ownerSelectOptions[0])
          setActiveTabId("HOME")
          history.push(`/ClosePortal/HOME/Page/${ownerSelectOptions[0]}`)
        } else {
          setSelectedCPView(ownerSelectOptions[index])
        }
      } else {
        setSelectedCPView(ownerSelectOptions[0])
      }
    }
  }

  const loadData = async () => {
      // setShowLoadingIcon(true)
      if(isPortalAdmin || isSupportAdmin){
        const r = await getOwnersForAdminUser(function onSuccess(result) {
                   const data = result.data.getOwnersForAdminUserRDS
                   const owners = JSON.parse(data)
                   const ownerSelectOptions = owners.map((owner) => {
                     return {label:owner?.owner_name, value:String(owner?.owner_id), owner_identifier:owner?.owner_identifier, owner_type: owner?.owner_type}
                   })
                   setCpOwnerOptions(ownerSelectOptions)
                   handleOwnerSelection(ownerSelectOptions)
                   configureGenericAppSync()
                   setShowLoadingIcon(false)
               }, function onFailure(response) {
                   configureGenericAppSync()
                   setShowLoadingIcon(false)
               })
      } else {
       if (cacheVariables[GET_OWNERS_CACHE_KEY].useCache) {
         const cachedData = getCachedOwners();
         if (cachedData) {
           setCpOwnerOptions(cachedData)
           handleOwnerSelection(cachedData)
           configureGenericAppSync()
           setShowLoadingIcon(false)
           return;
         }
       }
       
       const r = await getOwnersByUser(currentStage, function onSuccess(result) {
                   const data = result.data.getOwnersByUser
                   const owners = JSON.parse(data)
                   const ownerSelectOptions = owners.map((owner) => {
                     return {label:owner?.owner_name, value:owner?.owner_id, owner_identifier:owner?.owner_identifier, owner_type: owner?.owner_type}
                   })
                   if (cacheVariables[GET_OWNERS_CACHE_KEY].useCache) {
                     setCachedOwners(ownerSelectOptions)
                   }
                   setCpOwnerOptions(ownerSelectOptions)
                   handleOwnerSelection(ownerSelectOptions)
                   configureGenericAppSync()
                   setShowLoadingIcon(false)
               }, function onFailure(response) {
                   configureGenericAppSync()
                   setShowLoadingIcon(false)
               })
      }
  }

  const updateAccess = async () => {

    if (selectedCPView && selectedCPView?.owner_type === 'DEFAULT') {
          setViewAccess(true)
          if (isSupportAdmin || isPortalAdmin) {
              setAddOrEditAccess(true)
          } else {
              setAddOrEditAccess(false)
          }
      } else if (selectedCPView && selectedCPView?.owner_type === 'TEAM') {
          const isLDAPMemberOf = await isMemberOf(currentUser, selectedCPView?.owner_identifier, currentStage)
          let isLDAPOwnerOf;
          await configurePlusAppsync()
          const res = await getBrassIsLDAPOwnerOf(selectedCPView?.owner_identifier, currentStage, function onSuccess(result) {
              isLDAPOwnerOf = result.data.getBrassIsLDAPOwnerOf
              // setIsLDAPOwnerOf(data) 
              if (isLDAPOwnerOf || isLDAPMemberOf || isSupportAdmin || isPortalAdmin) {
                  setViewAccess(true)
              } else {
                  setViewAccess(false)
              }

              if (isLDAPOwnerOf || isSupportAdmin || isPortalAdmin) {
                  setAddOrEditAccess(true)
              } else {
                  setAddOrEditAccess(false)
              }
              configureGenericAppSync()
          }, function onFailure(response) {
              configureGenericAppSync()
          })
      } else if (selectedCPView && selectedCPView?.owner_type === 'USER' && selectedCPView?.owner_identifier === currentUser) {
          setViewAccess(true)
          setAddOrEditAccess(true)
      } else {
          setViewAccess(false)
          setAddOrEditAccess(false)
      }
  }

  const updateCustomTabs = async() => {
    setAllTabs([])
    if (selectedCPView) {
      const excludeHidden = true
      await getOwnerCustomTabs(selectedCPView?.value, excludeHidden, function onSuccess(result) {
              const customTabs = result.data.getOwnerCustomTabs
              // setIsLDAPOwnerOf(data) 
              setTabs(JSON.parse(customTabs))
              setCustomTabsLoaded(true)
              configureGenericAppSync()
          }, function onFailure(response) {
              configureGenericAppSync()
          })
      
    }
  }

  const fetchAllTabsOfOwner = async () => {
    const excludeHidden = false
    await getOwnerCustomTabs(selectedCPView?.value, excludeHidden, function onSuccess(result) {
        const allCustomTabs = result.data.getOwnerCustomTabs
        setAllTabs(JSON.parse(allCustomTabs).map((cTab) => (cTab?.tab)).concat(closePortalDefaultTabs.map((tab)=>(tab?.name))))
        setAllCustomTabs(JSON.parse(allCustomTabs).map((cTab) => (cTab?.tab)))
        configureGenericAppSync()
    }, function onFailure(response) {
        configureGenericAppSync()
    })
  }
  
  const fetchHiddenTabsOfOwner = async () => {
    const preferenceType = "HIDE_TAB"
    await getOwnerTabPreferences(selectedCPView?.value, preferenceType, function onSuccess(result) {
        const tabs = result.data.getOwnerTabPreferences
        setHiddenTabs(JSON.parse(tabs).filter((cTab) => (cTab?.preference === true)).map((t)=>(t.tab)))
        setFetchedHiddenTabsOfOwner(true)
        configureGenericAppSync()
    }, function onFailure(response) {
        configureGenericAppSync()
    })
  }
  const updateTab = (tabId, href) => {
    if(closePortalDefaultTabs?.filter((t) => (hiddenTabs?.includes(t?.id) ? false : true))?.map((tab)=>(tab?.id)).concat(tabs?.map((t) => (t?.tab)))?.includes(tabId)) {
     setActiveHref(href)
     setActiveTabId(tabId)
     return true;
    } else {
      return false;
    }
    
  }

  const hideOrUnhideCustomTab = async (tab, hide) => {

    setModalLoading(true)
    await hideOrUnhideCPTab(selectedCPView?.value, tab, hide, function onSuccess(result) {
              setTabs(tabs?.filter((customTab) => (customTab?.tab !== tab)))
              fetchAllTabsOfOwner()
              fetchHiddenTabsOfOwner()
              updateCustomTabs()
              resetModalParams()
              configureGenericAppSync()
          }, function onFailure(response) {
              configureGenericAppSync()
          })
    
  }

  const addNewCustomTab = async () => {
      if(newTabName?.trim() !== '' && selectedTabType) {
        if(allCustomTabs?.length >= 10) {
          setErrorText('Cannot create more than 10 custom tabs!')
          return;
        } else if(allTabs?.includes(newTabName?.trim())) {
          setErrorText('A tab with same name exists!')
          return;
        } else {
          setModalLoading(true)
          await createCustomTabOfOwner(newTabName?.trim(), selectedCPView?.value, currentUser, selectedTabType?.value, function onSuccess(result) {
              fetchAllTabsOfOwner()
              fetchHiddenTabsOfOwner()
              updateCustomTabs()
              resetModalParams()
              configureGenericAppSync()
          }, function onFailure(response) {
              configureGenericAppSync()
          })
        }
      } else {
        setErrorText('All fields are required!')
        return;
      }
  }

  const updateExistingCustomTab = async () => {
      if(selectedUpdateOrDeleteTab) {
        if(updateTabNameInput?.trim() === '') {
          setErrorText('Please provide a new tab name to update!')
          return;
        } else if(allTabs?.includes(updateTabNameInput?.trim())) {
          setErrorText('A tab with same name exists!')
          return;
        } else {
          setModalLoading(true)
          await updateCustomTabOfOwner( selectedCPView?.value, selectedUpdateOrDeleteTab?.value, updateTabNameInput?.trim(), function onSuccess(result) {
              fetchAllTabsOfOwner()
              fetchHiddenTabsOfOwner()
              updateCustomTabs()
              resetModalParams()
              configureGenericAppSync()
          }, function onFailure(response) {
              configureGenericAppSync()
          })
        }
      } else {
        setErrorText('Please select a tab to update!')
        return;
      }
  }

  const deleteExistingCustomTab = async () => {
    if(selectedUpdateOrDeleteTab) {
      setModalLoading(true)
          await deleteCustomTabOfOwner( selectedCPView?.value, selectedUpdateOrDeleteTab?.value, function onSuccess(result) {
              fetchAllTabsOfOwner()
              fetchHiddenTabsOfOwner()
              updateCustomTabs()
              resetModalParams()
              setActiveTabId("HOME")
              configureGenericAppSync()
          }, function onFailure(response) {
              configureGenericAppSync()
          })
        
      } else {
        setErrorText('Please select a tab to delete!')
        return;
      }
  }

  const resetModalParams = () => {
    setVisible(false)
    setCustomizeTabsVisible(false)
    setModalLoading(false)
    setErrorText()
    setSelectedSegmentId("tab-controls")
    setSelectedTabControlsSegmentId("add")
    setNewTabName('')
    setSelectedUpdateOrDeleteTab()
    setUpdateTabNameInput('')
    setSelectedTabToUnhide()
    setSelectedOrgs([])
    setSelectedRegions([])
    setNewTeamName('')
    setNewTeamLDAP('')
    setSelectedVP()
    setSelectedTeamToEdit(null)
  }

  const createNewOwner = async (ownerType='TEAM') => {
      const missingFields = [];
      
      if (!newTeamName?.trim()) {
        missingFields.push('Team Display name');
      }
      if (!newTeamLDAP?.trim()) {
        missingFields.push('LDAP');
      }
      if (!selectedOrgs || selectedOrgs.length === 0) {
        missingFields.push('Organization');
      }
      if (!selectedRegions || selectedRegions.length === 0) {
        missingFields.push('Region');
      }
      if (!selectedVP) {
        missingFields.push('VP');
      }

      if (missingFields.length > 0) {
        setErrorText(`Please fill in all required fields: ${missingFields.join(', ')}`);
        return;
      }

      setModalLoading(true)
      let regions = []
      let orgs = []
      let vps = []
      
      if(selectedOrgs?.length >= 1) {
        orgs = selectedOrgs?.map((org) => (org?.value))
      }
      if(selectedRegions?.length >= 1) {
        regions = selectedRegions?.map((region) => (region?.value))
      }
      if(selectedVP) {
        vps = [selectedVP?.value]
      }

      await createClosePortalOwner( newTeamName?.trim(), newTeamLDAP?.trim(), ownerType, currentUser, orgs, regions, vps, function onSuccess(result) {
          localStorage.removeItem(GET_OWNERS_CACHE_KEY);
          loadData()
          resetModalParams()
          configureGenericAppSync()
      }, function onFailure(response) {
          setErrorText(response)
          setModalLoading(false)
          configureGenericAppSync()
      })
  }

  const sanitizeResponseData = (data) => {
    if (!data || typeof data !== 'string') {
      return data;
    }
    
    try {
      
      let sanitized = data;
      
      sanitized = sanitized.replace(/(\w+)=/g, '"$1":');
      
      sanitized = sanitized.replace(/:\s*\[([^\]]*)\]/g, (match, arrayContent) => {
        if (!arrayContent.trim()) {
          return ': []';
        }
        
        const elements = [];
        let currentElement = '';
        let inQuotes = false;
        
        for (let i = 0; i < arrayContent.length; i++) {
          const char = arrayContent[i];
          
          if (char === '"' && (i === 0 || arrayContent[i-1] !== '\\')) {
            inQuotes = !inQuotes;
            currentElement += char;
          } else if (char === ',' && !inQuotes) {
            if (currentElement.trim()) {
              elements.push(currentElement.trim());
            }
            currentElement = '';
          } else {
            currentElement += char;
          }
        }
        
        if (currentElement.trim()) {
          elements.push(currentElement.trim());
        }
        
        const processedElements = elements.map(element => {
          const trimmed = element.trim();
          
          if (trimmed.startsWith('"') && trimmed.endsWith('"')) {
            return trimmed;
          }
          
          if (/^[\d.]+$/.test(trimmed)) {
            return trimmed;
          }
          
          if (/^(true|false|null)$/i.test(trimmed)) {
            return trimmed.toLowerCase();
          }
          
          return `"${trimmed}"`;
        });
        
        return `: [${processedElements.join(', ')}]`;
      });
      
      sanitized = sanitized.replace(/:\s*([^,\[\]{}"\d\s][^,\[\]{}]*?)(?=[,\]}])/g, (match, value) => {
        const trimmedValue = value.trim();
        
        if (trimmedValue.startsWith('"') || 
            /^[\d.]+$/.test(trimmedValue) || 
            /^(true|false|null)$/i.test(trimmedValue) ||
            trimmedValue.startsWith('[') || 
            trimmedValue.startsWith('{')) {
          return `: ${trimmedValue}`;
        }
        
        return `: "${trimmedValue}"`;
      });
      
      sanitized = sanitized.replace(/:\s*([^,\[\]{}"][^,\[\]{}]*[^,\[\]{}"])(?=[,\]}])/g, (match, value) => {
        const trimmedValue = value.trim();
        
        if (!trimmedValue.startsWith('"') && 
            !trimmedValue.endsWith('"') &&
            !/^[\d.]+$/.test(trimmedValue) &&
            !/^(true|false|null)$/i.test(trimmedValue)) {
          return `: "${trimmedValue}"`;
        }
        
        return `: ${trimmedValue}`;
      });
      
      
      return JSON.parse(sanitized);
    } catch (error) {
      console.error('Failed to sanitize data:', error);
      console.error('Original data:', data);
      console.error('Attempted sanitization:', sanitized);
      
      try {
        let fallbackSanitized = data
          .replace(/(\w+)=/g, '"$1":')
          .replace(/:\s*([^,\[\]{}]+?)(?=[,\]}])/g, (match, value) => {
            const trimmed = value.trim();
            if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
              const arrayContent = trimmed.slice(1, -1);
              if (!arrayContent.trim()) return ': []';
              
              const elements = arrayContent.split(',').map(el => {
                const element = el.trim();
                if (/^[\d.]+$/.test(element) || /^(true|false|null)$/i.test(element)) {
                  return element;
                }
                return `"${element}"`;
              });
              
              return `: [${elements.join(', ')}]`;
            }
            
            if (/^[\d.]+$/.test(trimmed) || /^(true|false|null)$/i.test(trimmed)) {
              return `: ${trimmed}`;
            }
            
            return `: "${trimmed}"`;
          });
        
        return JSON.parse(fallbackSanitized);
      } catch (fallbackError) {
        console.error('Fallback sanitization also failed:', fallbackError);
        throw new Error('Invalid data format received from server - unable to parse');
      }
    }
  };

  const checkAteamBIMembership = () => {
    setIsAteamBI(isPortalAdmin || isSupportAdmin);
  }

  const loadTeamDetails = async (teamId, retryCount = 0) => {
    setModalLoading(true);
    
    setErrorText('');
    
    await getOwnerDetails(teamId, function onSuccess(result) {
      try {
        const data = result.data.getOwnerDetailsRDS;
        
        if (!data) {
          console.error('No data returned from getOwnerDetailsRDS');
          setErrorText('No team data found');
          configureGenericAppSync();
          setModalLoading(false);
          return;
        }
        
        let teamDetails;
        
        if (typeof data === 'string') {
          if (data.trim() === '' || data.trim() === 'null' || data.trim() === 'undefined') {
            console.error('Empty or invalid data string:', data);
            setErrorText('Invalid team data format');
            configureGenericAppSync();
            setModalLoading(false);
            return;
          }
          
          try {
            teamDetails = JSON.parse(data);
          } catch (parseError) {
            try {
              teamDetails = sanitizeResponseData(data);
            } catch (sanitizeError) {
              console.error('JSON parse error for data:', data);
              console.error('Parse error details:', parseError);
              console.error('Sanitization error:', sanitizeError);
              setErrorText('Failed to parse team data - invalid format received from server');
              configureGenericAppSync();
              setModalLoading(false);
              return;
            }
          }
        } else if (Array.isArray(data)) {
          teamDetails = data;
        } else if (data && typeof data === 'object') {
          teamDetails = [data];
        } else {
          console.error('Unexpected data format:', data);
          setErrorText('Unexpected team data format');
          configureGenericAppSync();
          setModalLoading(false);
          return;
        }
        
        
        if (teamDetails && Array.isArray(teamDetails) && teamDetails.length > 0) {
          const team = teamDetails[0];
          
          setNewTeamName(team.owner_name || '');
          setNewTeamLDAP(team.owner_identifier || '');
          
          if (team.organizations !== undefined && team.organizations !== null) {
            try {
              let orgData = team.organizations;
              
              if (typeof orgData === 'string' && orgData.trim() !== '') {
                orgData = JSON.parse(orgData);
              }
              
              if (Array.isArray(orgData)) {
                const teamOrgs = orgData.map(org => 
                  organizations?.find(o => o.value === org) || { label: org, value: org }
                ).filter(Boolean);
                setSelectedOrgs(teamOrgs);
              } else {
                setSelectedOrgs([]);
              }
            } catch (e) {
              console.error('Error parsing organizations:', e);
              setSelectedOrgs([]);
            }
          } else {
            setSelectedOrgs([]);
          }
          
          if (team.regions !== undefined && team.regions !== null) {
            try {
              let regionData = team.regions;
              
              if (typeof regionData === 'string' && regionData.trim() !== '') {
                regionData = JSON.parse(regionData);
              }
              
              if (Array.isArray(regionData)) {
                const teamRegions = regionData.map(region => 
                  regions?.find(r => r.value === region) || { label: region, value: region }
                ).filter(Boolean);
                setSelectedRegions(teamRegions);
              } else {
                setSelectedRegions([]);
              }
            } catch (e) {
              console.error('Error parsing regions:', e);
              setSelectedRegions([]);
            }
          } else {
            setSelectedRegions([]);
          }
          
          if (team.vps !== undefined && team.vps !== null) {
            try {
              let vpData = team.vps;
              
              if (typeof vpData === 'string' && vpData.trim() !== '') {
                vpData = JSON.parse(vpData);
              }
              
              if (Array.isArray(vpData) && vpData.length > 0) {
                const vp = directReports?.find(dr => dr.value === vpData[0]) || 
                          { label: vpData[0], value: vpData[0] };
                setSelectedVP(vp);
              } else {
                setSelectedVP(null);
              }
            } catch (e) {
              console.error('Error parsing VPs:', e);
              setSelectedVP(null);
            }
          } else {
            setSelectedVP(null);
          }
        } else {
          console.error('No valid team details found');
          setErrorText('No team details found');
        }
        
        configureGenericAppSync();
        setModalLoading(false);
      } catch (error) {
        console.error('Error in loadTeamDetails:', error);
        setErrorText('Failed to load team details: ' + error.message);
        configureGenericAppSync();
        setModalLoading(false);
      }
    }, function onFailure(response) {
      console.error('getOwnerDetails failed:', response);
      
      if (response && (
          response.message?.includes('ERR_SOCKET_NOT_CONNECTED') ||
          response.message?.includes('Network Error') ||
          response.message?.includes('ERR_NETWORK') ||
          response.networkError
        ) && retryCount < 2) {
        setErrorText(`Network error, retrying... (${retryCount + 1}/3)`);
        
        setTimeout(() => {
          loadTeamDetails(teamId, retryCount + 1);
        }, 1000 * (retryCount + 1)); 
        return;
      }
      
      if (retryCount >= 2) {
        setErrorText('Failed to load team details after multiple attempts. Please check your network connection and try again.');
      } else {
        setErrorText('Failed to load team details. Please try again.');
      }
      
      configureGenericAppSync();
      setModalLoading(false);
    });
  }

  const updateTeam = async () => {
    const missingFields = [];
    
    if (!selectedTeamToEdit) {
      missingFields.push('Team selection');
    }
    if (!newTeamName?.trim()) {
      missingFields.push('Team Display name');
    }
    if (!newTeamLDAP?.trim()) {
      missingFields.push('LDAP');
    }
    if (!selectedOrgs || selectedOrgs.length === 0) {
      missingFields.push('Organization');
    }
    if (!selectedRegions || selectedRegions.length === 0) {
      missingFields.push('Region');
    }
    if (!selectedVP) {
      missingFields.push('VP');
    }

    if (missingFields.length > 0) {
      setErrorText(`Please fill in all required fields: ${missingFields.join(', ')}`);
      return;
    }

    setModalLoading(true);
    
    let regions = [];
    let orgs = [];
    let vps = [];
    
    if (selectedOrgs?.length >= 1) {
      orgs = selectedOrgs?.map((org) => (org?.value));
    }
    if (selectedRegions?.length >= 1) {
      regions = selectedRegions?.map((region) => (region?.value));
    }
    if (selectedVP) {
      vps = [selectedVP?.value];
    }

    await updateClosePortalOwner(
      selectedTeamToEdit.value,
      newTeamName?.trim(),
      newTeamLDAP?.trim(),
      orgs,
      regions,
      vps,
      currentUser,
      function onSuccess(result) {
        localStorage.removeItem(GET_OWNERS_CACHE_KEY);
        loadData();
        resetModalParams();
        configureGenericAppSync();
      },
      function onFailure(response) {
        setErrorText(response || 'Failed to update team');
        setModalLoading(false);
        configureGenericAppSync();
      }
    );
  }

  const resetHref = () => {
    setActiveHref()
  }

  const handleReorderTabs = async (newOrder) => {
    if (selectedCPView?.value) {
      try {
        setModalLoading(true);
        
        await saveTabOrder(selectedCPView.value, newOrder);
        
        await loadOrderedTabs(true);
        
        setCustomizeTabsVisible(false);
        setModalLoading(false);
        setErrorText();
        setSelectedTabControlsSegmentId("add");
        
      } catch (error) {
        console.error('Failed to save tab order:', error);
        setErrorText('Failed to save tab order. Please try again.');
        setModalLoading(false);
      }
    }
  };

  const getVisibleTabsForReorder = () => {
    if (!selectedCPView) return [];
    
    const visibleDefaultTabs = closePortalDefaultTabs
      .filter(tab => !hiddenTabs.includes(tab.id) && !FIXED_TABS.includes(tab.id))
      .map(tab => tab.id);
    
    const visibleCustomTabs = tabs
      .filter(tab => !hiddenTabs.includes(tab.tab))
      .map(tab => tab.tab);

    return [...visibleDefaultTabs, ...visibleCustomTabs];
  };

  const [orderedTabs, setOrderedTabs] = useState({ 
        fixedTabs: closePortalDefaultTabs.filter(tab => FIXED_TABS.includes(tab.id)),
        orderedReorderableTabs: [
          ...closePortalDefaultTabs.filter(tab => !FIXED_TABS.includes(tab.id)),
          ...tabs
        ]
      });
  const [tabOrderLoaded, setTabOrderLoaded] = useState(false);

  const loadOrderedTabs = async (forceRefresh = false) => {
    if (!selectedCPView?.value) {
      setOrderedTabs({ 
        fixedTabs: closePortalDefaultTabs.filter(tab => FIXED_TABS.includes(tab.id)),
        orderedReorderableTabs: [
          ...closePortalDefaultTabs.filter(tab => !FIXED_TABS.includes(tab.id)),
          ...tabs
        ]
      });
      setTabOrderLoaded(true);
      return;
    }

    try {
      const savedOrder = await getTabOrder(selectedCPView.value, forceRefresh);
      const visibleDefaultTabs = closePortalDefaultTabs.filter(tab => !hiddenTabs.includes(tab.id));
      const visibleCustomTabs = tabs.filter(tab => !hiddenTabs.includes(tab.tab));
      
      
      const fixedTabs = visibleDefaultTabs.filter(tab => FIXED_TABS.includes(tab.id));
      const reorderableDefaultTabs = visibleDefaultTabs.filter(tab => !FIXED_TABS.includes(tab.id))?.map((t)=>({...t, type: 'default'}));
      const reorderableCustomTabs = visibleCustomTabs?.map((t) => ({...t, type: 'custom'}));


      if (!savedOrder) {
        setOrderedTabs({ 
          fixedTabs: fixedTabs,
          orderedReorderableTabs: [...reorderableDefaultTabs, ...reorderableCustomTabs]
        });
        setTabOrderLoaded(true);
        return;
      }

      const allReorderableTabs = [];
      
      savedOrder.forEach(tabId => {
        const defaultTab = reorderableDefaultTabs.find(tab => tab.id === tabId);
        if (defaultTab) {
          allReorderableTabs.push({ ...defaultTab, type: 'default' });
          return;
        }
        
        const customTab = reorderableCustomTabs.find(tab => tab.tab === tabId);
        if (customTab) {
          allReorderableTabs.push({ ...customTab, type: 'custom' });
        }
      });

      reorderableDefaultTabs.forEach(tab => {
        if (!allReorderableTabs.find(t => t.id === tab.id)) {
          allReorderableTabs.push({ ...tab, type: 'default' });
        }
      });
      
      reorderableCustomTabs.forEach(tab => {
        if (!allReorderableTabs.find(t => (t.tab === tab.tab || t.id === tab.tab))) {
          allReorderableTabs.push({ ...tab, type: 'custom' });
        }
      });



      setOrderedTabs({ 
        fixedTabs: fixedTabs,
        orderedReorderableTabs: allReorderableTabs
      });
      setTabOrderLoaded(true);
    } catch (error) {
      console.warn('Failed to load ordered tabs:', error);
      setOrderedTabs({ 
        fixedTabs: closePortalDefaultTabs.filter(tab => FIXED_TABS.includes(tab.id)),
        orderedReorderableTabs: [
          ...closePortalDefaultTabs.filter(tab => !FIXED_TABS.includes(tab.id)),
          ...tabs
        ]
      });
      setTabOrderLoaded(true);
    }
  };

  useEffect(() => {
    if (selectedCPView?.value && customTabsLoaded && fetchedHiddenTabsOfOwner) {
      loadOrderedTabs();
    } else {
      setTabOrderLoaded(false);
    }
  }, [selectedCPView, customTabsLoaded, fetchedHiddenTabsOfOwner, tabs, hiddenTabs]);
  const Content = (
    showLoadingIcon ?
    <Box>
      <Spinner size="large" />
    </Box>
    :
    
    <Box>
      <br></br>
      <ContentLayout
      >

        <Header
        actions={
        
          <Button
                ariaLabel="Open our t.corp template (opens in new tab)"
                href="https://t.corp.amazon.com/create/templates/9c41d7b9-b693-433e-950a-ec29fcfce9f5"
                iconAlign="right"
                iconName="external"
                target="_blank"
              >
                Contact us
            </Button>
      }
      >

          <Box>
            <SpaceBetween direction="vertical" size="m">
              <Box  
              variant="h3"
            padding="n"
            fontSize="heading-l"
            color="inherit">{greeting}, {firstName}</Box>
              {selectedCPView?.label && (
                <Box padding={{bottom:"s"}}>
                  <Box   variant="h3"
         
            fontSize="heading-l"
            display="inline">Welcome to </Box>
                  <Link
                    href={`https://${currentStage === 'prod' ? '' : 'beta.'}bi-central.accounting.amazon.dev`}
                    variant="secondary"
                    external={inIframe}
                    fontSize="heading-l"
         
                  >
                 <strong>  ATEAM's Close Portal </strong> 
                  </Link>
                  {activeTabId !== 'AppsLibrary' && (
                    <>
                      <Box  variant="h3"
            padding="n"
            fontSize="heading-l" display="inline"> - You are viewing the </Box>
                      {selectedCPView && cpOwnerOptions && cpOwnerOptions.length > 0 && (
                        <Box display="inline-block" margin={{ left: 'xs', right: 'xs' }}>
                          <Select
                            className="owner-select-dropdown"
                            selectedOption={selectedCPView}
                            onChange={({ detail }) => {
                              setSelectedCPView(detail.selectedOption)
                            }}
                            options={cpOwnerOptions}
                            disabled={false}
                            filteringType="auto"
                          />
                        </Box>
                      )}
                      <Box  variant="h3"
            padding="n"
            fontSize="heading-l" display="inline"> page </Box>
                      {addOrEditAccess && (
                        <Box display="inline-block" margin={{ left: 'xs' }}>
                          <Button
                            variant="icon"
                            iconName="settings"
                            onClick={() => { setVisible(true) }}
                            ariaLabel="Page settings"
                          />
                        </Box>
                      )}
                    </>
                  )}
                </Box>
              )}
            </SpaceBetween>
          </Box>
          {/* </SpaceBetween> */}
        </Header>
        <Container>
          <BannerContainer displayLocations={[BannerDisplayLocation.ClosePortal]} roundedCorners={true} parameters={{closePortalOwnerId: selectedCPView?.value}} />

          {addOrEditAccess && activeTabId !== 'AppsLibrary' && (
            <Box float="right" margin={{ top: 's', bottom: 's' }}>
              <Link
                variant="primary"
                fontSize="heading-m"
                onFollow={() => setCustomizeTabsVisible(true)}
              >
                Customize Tabs
              </Link>
            </Box>
          )}
          <br />
            <Tabs
              tabs={(() => {
                const { fixedTabs, orderedReorderableTabs } = orderedTabs;

          const fixedTabItems = fixedTabs.map((tab) => ({
            label: ((tabOrderLoaded === true) || tab?.id === 'HOME' || tab?.id === 'AppsLibrary') ? tab?.name : 'Loading',
            id: tab?.id,
            disabled: (tab?.id !== 'HOME' && tab?.id !== 'AppsLibrary' && !(tabOrderLoaded)),
            content: (
              tab?.tab_type === 'BOARD' ? (
                <CPBoardView
                  pageType={tab?.id}
                  tabType={tab?.tab_type}
                  owner={selectedCPView}
                  openResource={updateTab}
                  viewAccess={viewAccess}
                  addOrEditAccess={addOrEditAccess}
                />
              ) : tab?.tab_type === 'APPS' ? (
                <Apps />
              ) : tab?.tab_type === 'LIST' ? (
                <CustomMultipleResourcePage
                  pageType={tab?.id}
                  tabType={tab?.tab_type}
                  owner={selectedCPView}
                  activeHref={activeHref}
                  viewAccess={viewAccess}
                  addOrEditAccess={addOrEditAccess}
                  resetHref={resetHref}
                />
              ) : (
                <></>
              )
            ),
            action: (
              (isPortalAdmin && tab?.id !== 'HOME' && tab?.id !== 'AppsLibrary' ||
                (addOrEditAccess && tab?.id !== 'HOME' && tab?.id !== 'AppsLibrary' && tab?.id !== 'AI/ML')) &&
              <ButtonDropdown
                items={[{ id: "hide-tab", text: "hide tab for team" }]}
                ariaLabel="tab actions"
                variant="icon"
                onItemClick={(event) => {
                  if (event?.detail?.id === 'hide-tab') {
                    hideOrUnhideCustomTab(tab?.id, true);
                  }
                }}
                expandToViewport={true}
              />
            )
          }));

          const reorderableTabItems = orderedReorderableTabs.map((tab) => {
            const isCustomTab = tab.type === 'custom';
            const tabId = isCustomTab ? tab.tab : tab.id;
            const tabName = isCustomTab ? tab.tab : tab.name;
            const tabType = isCustomTab ? tab.tab_type : tab.tab_type;

            return {
              label: ((tabOrderLoaded === true) || tabId === 'HOME' || tabId === 'AppsLibrary') ? tabName : 'Loading',
              id: tabId,
              disabled: (tabId !== 'HOME' && tabId !== 'AppsLibrary' && !(tabOrderLoaded)),
              content: (
                tabType === 'BOARD' ? (
                  <CPBoardView
                    pageType={tabId}
                    tabType={tabType}
                    owner={selectedCPView}
                    openResource={updateTab}
                    viewAccess={viewAccess}
                    addOrEditAccess={addOrEditAccess}
                  />
                ) : tabType === 'APPS' ? (
                  <Apps />
                ) : tabType === 'LIST' ? (
                  <CustomMultipleResourcePage
                    pageType={tabId}
                    tabType={tabType}
                    owner={selectedCPView}
                    activeHref={activeHref}
                    viewAccess={viewAccess}
                    addOrEditAccess={addOrEditAccess}
                    resetHref={resetHref}
                  />
                ) : (
                  <></>
                )
              ),
              action: (
                (isPortalAdmin && tabId !== 'HOME' && tabId !== 'AppsLibrary' ||
                  (addOrEditAccess && tabId !== 'HOME' && tabId !== 'AppsLibrary' && tabId !== 'AI/ML')) &&
                <ButtonDropdown
                  items={[{ id: "hide-tab", text: "hide tab for team" }]}
                  ariaLabel="tab actions"
                  variant="icon"
                  onItemClick={(event) => {
                    if (event?.detail?.id === 'hide-tab') {
                      hideOrUnhideCustomTab(tabId, true);
                    }
                  }}
                  expandToViewport={true}
                />
              )
            };
          });

          const allTabs = fixedTabItems.concat(reorderableTabItems);

          return allTabs;

              })()}
              activeTabId={activeTabId}
              onChange={(event) => { 
                setActiveHref()
                if(event.detail.activeTabId === 'AppsLibrary') {
                  history.push(`/AppsLibrary`)
                } else {
                history.push(`/ClosePortal/${event.detail.activeTabId?.replaceAll('/','%2F')}/Page/${selectedCPView?.value}`)
                }
                setActiveTabId(event.detail.activeTabId) }}
            />
          {/* )} */}

          <CreateTeamModal
            visible={visible}
            onDismiss={resetModalParams}
            onCreateTeam={createNewOwner}
            onUpdateTeam={updateTeam}
            isPortalAdmin={isPortalAdmin}
            isSupportAdmin={isSupportAdmin}
            modalLoading={modalLoading}
            errorText={errorText}
            newTeamName={newTeamName}
            setNewTeamName={setNewTeamName}
            newTeamLDAP={newTeamLDAP}
            setNewTeamLDAP={setNewTeamLDAP}
            selectedOrgs={selectedOrgs}
            setSelectedOrgs={setSelectedOrgs}
            selectedRegions={selectedRegions}
            setSelectedRegions={setSelectedRegions}
            selectedVP={selectedVP}
            setSelectedVP={setSelectedVP}
            organizations={organizations}
            regions={regions}
            directReports={directReports}
            getDirectReportsCaller={getDirectReportsCaller}
            availableTeams={cpOwnerOptions?.filter(team => team.owner_type === 'TEAM')}
            selectedTeamToEdit={selectedTeamToEdit}
            setSelectedTeamToEdit={setSelectedTeamToEdit}
            isAteamBI={isAteamBI}
            onLoadTeamDetails={loadTeamDetails}
            onClearError={() => setErrorText('')}
          />

          <CustomizeTabsModal
            visible={customizeTabsVisible}
            onDismiss={() => {
              setCustomizeTabsVisible(false)
              setModalLoading(false)
              setErrorText()
              setSelectedTabControlsSegmentId("add")
              setNewTabName('')
              setSelectedUpdateOrDeleteTab()
              setUpdateTabNameInput('')
              setSelectedTabToUnhide()
            }}
            modalLoading={modalLoading}
            errorText={errorText}
            allTabs={allTabs}
            allCustomTabs={allCustomTabs}
            hiddenTabs={hiddenTabs}
            selectedTabControlsSegmentId={selectedTabControlsSegmentId}
            setSelectedTabControlsSegmentId={setSelectedTabControlsSegmentId}
            newTabName={newTabName}
            setNewTabName={setNewTabName}
            selectedUpdateOrDeleteTab={selectedUpdateOrDeleteTab}
            setSelectedUpdateOrDeleteTab={setSelectedUpdateOrDeleteTab}
            updateTabNameInput={updateTabNameInput}
            setUpdateTabNameInput={setUpdateTabNameInput}
            selectedTabToUnhide={selectedTabToUnhide}
            setSelectedTabToUnhide={setSelectedTabToUnhide}
            onAddTab={addNewCustomTab}
            onUpdateTab={updateExistingCustomTab}
            onDeleteTab={deleteExistingCustomTab}
            selectedTabType={selectedTabType}
            setSelectedTabType={setSelectedTabType}
            onUnhideTab={() => {
              if(selectedTabToUnhide) {
                hideOrUnhideCustomTab(selectedTabToUnhide?.value, false)
              } else {
                setErrorText('Please select a tab to unhide!')
              }
            }}
            visibleTabs={getVisibleTabsForReorder()}
            onReorderTabs={handleReorderTabs}
            orderedTabs={orderedTabs}
            selectedCPView={selectedCPView}
          />

        </Container>
      </ContentLayout>


    </Box>
  );
  return (
    <AppLayout
      disableContentPaddings={false}
      // navigation={<SideNav activeHref={ln.pathname} orgs={organizations} />}
      maxContentWidth={Number.MAX_VALUE}
      navigationHide={true}
      content={Content}
      contentType="default"
      headerSelector="#TopBar"
      toolsHide={true}
    // onNavigationChange={() => {
    //   setNavOpen(!NavOpen);
    // }}
    />
  );
};

export default AllProducts;
